import React, { memo } from 'react';
import style from './index.module.scss';
import SortSelect from './SortSelect';
import MobileFilter from './MobileFilter';
import type { InitQueryType } from '../index';
import type { MallParams } from '@/stores';

interface Props {
  isNormalProduct?: boolean;
  changeFator: (fator: MallParams) => void;
  initValues: InitQueryType;
}

const Fator: React.FC<Props> = ({
  isNormalProduct,
  initValues,
  changeFator,
}) => {
  return (
    <div className={style.mobileFator}>
      <div className={style.trigger}>
        <MobileFilter
          isNormalProduct={isNormalProduct}
          initValues={initValues}
          changeFator={changeFator}
        />
        <SortSelect initValue={initValues.ordering} />
      </div>
    </div>
  );
};

export default memo(Fator);
